import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinmarolmidc() {



  const cardData =
  {
    keyword: ' Cab Service in Marol MIDC Andheri',
    heading: 'Pune Corporate Cars India Private Limited: Cab Service in Marol MIDC Andheri',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Cab Service in Marol MIDC Andheri, designed to support the transportation needs of corporate offices, industrial facilities, and business parks in the area. Our fleet of well-maintained sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior management. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or executive movement, we deliver smooth and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and dedicated service support, Pune Corporate Cars India Private Limited ensures a premium and dependable travel experience for businesses operating in and around Marol MIDC Andheri.',

    top: 'Top Places to Visit in Marol with Pune Corporate Car',

 "topPlaces": [
    {
      "title": "Bandra Kurla Complex (BKC)",
      "description": "Bandra Kurla Complex is Mumbai’s premier financial and commercial district, home to multinational corporations, consulates, global banks, Fortune 500 headquarters, and luxury business hotels. The area includes iconic business towers such as Jio World Centre, Naman Chambers, and The Capital. BKC is the top hotspot for corporate meetings, high-profile events, executive travel, and airport transfers—making it one of the busiest destinations for corporate cab services."
    },
    {
      "title": "Lower Parel Corporate Hub",
      "description": "Lower Parel is Mumbai’s most dynamic corporate zone, combining high-rise office towers like One Indiabulls Centre, Peninsula Business Park, and Lodha World Towers. The area is filled with premium coworking spaces, studios, business hotels, and award-winning restaurants. With its mix of creative agencies, finance companies, and MNCs, Lower Parel demands fast, reliable corporate commuting throughout the day."
    },
    {
      "title": "Nariman Point Business District",
      "description": "Nariman Point is one of India’s oldest and most prestigious business districts, housing corporate headquarters, legal firms, government offices, and international consulates. Overlooking the Marine Drive seafront, it contains iconic commercial towers like Air India Building and Maker Chambers. High-density office traffic makes Nariman Point a prime route for corporate cab travel, especially during peak office hours."
    },
    {
      "title": "Andheri MIDC & SEEPZ",
      "description": "Andheri MIDC and SEEPZ SEZ are major industrial and tech zones in Mumbai, home to IT companies, export houses, manufacturing units, and global service providers. With thousands of employees working across multiple shifts, this zone witnesses high demand for employee transportation, shift-based staff travel, and corporate shuttle services throughout the day."
    },
    {
      "title": "Goregaon Nesco Business Park",
      "description": "Nesco IT Park in Goregaon East has become a major commercial destination with modern office towers, convention centers, and large corporate campuses. It hosts companies in IT, finance, BFSI, and media industries. Its proximity to the Western Express Highway and large employee base makes it one of the most active hubs for corporate cab requirements and executive travel."
    },
    {
      "title": "Powai Hiranandani Business District",
      "description": "Powai’s Hiranandani Business Park is a premium corporate environment featuring modern office complexes, luxury residences, and scenic surroundings. It hosts companies like Nomura, CRISIL, Deloitte, and JP Morgan. The area is known for high-end corporate travel, airport pickups, client meeting routes, and executive chauffeur services due to its professional working crowd."
    },
    {
      "title": "Vikhroli Godrej Business District",
      "description": "Vikhroli is home to the massive Godrej Business Park along with multiple commercial towers, IT campuses, and research facilities. Surrounded by greenery and located close to eastern business zones, it is a preferred location for tech firms and innovation centers. The daily movement of employees and corporate visitors creates consistent demand for premium mobility services."
    },
    {
      "title": "Andheri East Corporate Zone",
      "description": "Andheri East is Mumbai’s largest corporate cluster, packed with commercial towers like Solitaire Corporate Park, Ackruti Star, Times Square, and Hubtown Solaris. Its strategic location near Mumbai Airport makes it a hotspot for business travelers, frequent flyers, and client visits. Corporate cab services play a crucial role in daily commutes, airport drops, and inter-office travel."
    },
    {
      "title": "Malad Mindspace IT Park",
      "description": "Mindspace Malad is one of Mumbai’s biggest IT parks, hosting thousands of professionals working in tech, BPO, and corporate services. With companies like Amazon, Accenture, and JP Morgan operating here, the area runs round-the-clock mobility needs including daily office travel, night shift employee transportation, and executive cab services."
    },
    {
      "title": "Thane Ghodbunder Corporate Belt",
      "description": "Ghodbunder Road in Thane has rapidly grown into a major business corridor with IT parks, commercial complexes, and premium office towers. Corporate hubs like G:Corp, Orion Business Park, and TCS Olympus Centre bring huge employee footfall. It is well-connected to Mumbai, Navi Mumbai, and Thane, making it a high-demand route for corporate taxi and staff transportation services."
    }
  ],


"services": [
{
"name": "Marol MIDC Employee Cab",
"description": "Marol MIDC Employee Cab provides reliable and structured transportation for employees working in Marol MIDC. The service offers trained drivers, GPS-enabled vehicles, multi-shift scheduling, and optimized routes to ensure safe, comfortable, and punctual commuting for corporate and industrial staff."
},
{
"name": "Corporate Shuttle Andheri",
"description": "Corporate Shuttle Andheri delivers organized multi-passenger shuttle services for corporate offices, IT parks, and industrial units in Andheri. With GPS-monitored vehicles, professional drivers, structured routes, and multi-shift support, the service ensures efficient, safe, and timely employee transport."
},
{
"name": "Office Pickup Drop Marol",
"description": "Office Pickup Drop Marol offers dependable daily pickup and drop services for office employees and corporate staff. The service features punctual pickups, well-maintained vehicles, trained chauffeurs, and GPS-enabled tracking to ensure smooth and stress-free commuting."
},
{
"name": "Worker Cab Marol Andheri",
"description": "Worker Cab Marol Andheri provides structured transport solutions for factory and industrial workers in Marol and Andheri. The service includes multi-shift support, trained drivers, GPS-enabled vehicles, and safe, timely, and comfortable daily commuting."
},
{
"name": "Industrial Transport Marol MIDC",
"description": "Industrial Transport Marol MIDC specializes in transporting large numbers of employees across industrial units. The service ensures punctual, safe, and organized commuting with well-maintained vehicles, trained chauffeurs, GPS tracking, and structured multi-shift routes."
},
{
"name": "Monthly Cab Hire Marol",
"description": "Monthly Cab Hire Marol provides long-term cab rental solutions for companies requiring consistent employee commuting. The service includes fixed monthly plans, trained drivers, GPS-enabled vehicles, and structured routes to ensure reliable and efficient daily transport."
},
{
"name": "Business Travel Cab Andheri",
"description": "Business Travel Cab Andheri offers professional corporate transportation for executives, client visits, and business trips. The service features trained chauffeurs, GPS-enabled vehicles, well-maintained cars, and optimized routes for comfortable and punctual business travel."
},
{
"name": "Affordable Staff Cab Marol MIDC",
"description": "Affordable Staff Cab Marol MIDC provides cost-effective transportation solutions for employees in industrial and corporate offices. The service ensures reliable pickups, well-maintained vehicles, trained drivers, GPS tracking, and structured schedules for safe and budget-friendly commuting."
},
{
"name": "Outstation Cab Marol",
"description": "Outstation Cab Marol delivers long-distance travel solutions for corporate employees and business executives. The service features GPS-enabled vehicles, trained drivers, optimized routes, and comfortable seating to ensure safe, punctual, and hassle-free intercity commuting."
},
{
"name": "Sedan Cab Marol Andheri",
"description": "Sedan Cab Marol Andheri provides premium sedans for corporate staff, executives, and office visitors. The service ensures well-maintained vehicles, trained chauffeurs, GPS tracking, and punctual pickups for safe, comfortable, and professional commuting."
},
{
"name": "SUV Cab Andheri MIDC",
"description": "SUV Cab Andheri MIDC offers spacious and comfortable SUVs suitable for team travel, industrial staff transport, and executive commuting. The service includes trained chauffeurs, GPS-enabled vehicles, structured routes, and multi-shift support to ensure safe and reliable transportation."
},
{
"name": "Best Corporate Cab Marol",
"description": "Best Corporate Cab Marol provides top-quality corporate transportation for office staff, executives, and industrial employees. The service features punctual pickups, trained drivers, GPS-enabled vehicles, structured routes, and well-maintained sedans and SUVs for seamless commuting."
},
{
"name": "Employee Commute Andheri East",
"description": "Employee Commute Andheri East offers structured and dependable transport solutions for office and industrial employees. The service ensures GPS-monitored vehicles, trained drivers, multi-shift scheduling, and optimized routes for safe, comfortable, and timely commuting."
},
{
"name": "Corporate Fleet Marol MIDC",
"description": "Corporate Fleet Marol MIDC provides fully managed corporate fleet solutions, including sedans, SUVs, and staff cabs. The service covers vehicle maintenance, driver management, GPS tracking, and structured routes to ensure seamless, safe, and efficient employee transportation."
},
{
"name": "Staff Shuttle Andheri East",
"description": "Staff Shuttle Andheri East delivers organized multi-passenger shuttle services for corporate offices, IT parks, and industrial units. The service features trained drivers, GPS-enabled vehicles, structured routes, and multi-shift support for safe, punctual, and efficient staff commuting."
}
],

"tableData": [
["Marol MIDC Employee Cab", "Corporate Shuttle Andheri"],
["Office Pickup Drop Marol", "Worker Cab Marol Andheri"],
["Industrial Transport Marol MIDC", "Monthly Cab Hire Marol"],
["Business Travel Cab Andheri", "Affordable Staff Cab Marol MIDC"],
["Outstation Cab Marol", "Sedan Cab Marol Andheri"],
["SUV Cab Andheri MIDC", "Best Corporate Cab Marol"],
["Employee Commute Andheri East", "Corporate Fleet Marol MIDC"],
["Staff Shuttle Andheri East", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Marol MIDC Andheri",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable cab services in Marol MIDC Andheri, ensuring smooth and efficient transportation for corporate employees and executives."
  },
  {
    "WhyChooseheading": "Punctual Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure timely pickups and drops, helping employees reach offices, industrial zones, and business hubs in Marol MIDC Andheri efficiently."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring comfortable and secure commuting for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and designed for safe and comfortable corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible cab rental plans tailored to meet the commuting requirements of businesses and employees in Marol MIDC Andheri."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]
































  }

const faqData = [
  {
    question: 'Do you provide cab services in Marol MIDC, Andheri?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional cab services for employees and corporate clients in Marol MIDC, Andheri.',
  },
  {
    question: 'What types of cab services are available in Marol MIDC, Andheri?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and dedicated fleet solutions.',
  },
  {
    question: 'Do you support daily commuting for employees in Marol MIDC?',
    answer: 'Yes, we offer optimized daily commute solutions with timely pickups and flexible shift schedules for corporate offices in Andheri.',
  },
  {
    question: 'How can companies book cab services in Marol MIDC, Andheri?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers depending on employee strength and corporate needs.',
  },
  {
    question: 'Can companies avail long-term cab contracts in Marol MIDC, Andheri?',
    answer: 'Yes, we provide monthly, quarterly, and annual transportation contracts with flexible pricing and transparent terms.',
  },
  {
    question: 'Are safety and tracking features included in cab services?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide multi-shift transportation for employees in Marol MIDC?',
    answer: 'Yes, we manage transportation for multiple shifts including early morning, evening, night, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services in Marol MIDC, Andheri?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya Kulkarni',
    feedback: 'Professional cab service for employees in Marol MIDC, Andheri. Punctual, safe, and hassle-free transportation.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shreya Mehta',
    feedback: 'Excellent corporate cab service in Andheri. Smooth commuting experience for our team every day.',
    rating: 5,
  },
];





























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Marol MIDC Andheri",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-marol-midc.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited offers professional cab services in Marol MIDC Andheri, including employee transportation, office pickup & drop, staff commute solutions, industrial area transport, worker cabs, monthly corporate cab plans, shuttle services, business travel cabs, and chauffeur-driven executive vehicles for companies in Marol MIDC Andheri East.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/cab-service-marol-midc-andheri"
  }
};







  return (
    <div>
<Helmet>
  <title>Cab Service in Marol MIDC Andheri | Employee & Corporate Transport</title>

  <meta
    name="description"
    content="Reliable cab services in Marol MIDC Andheri including employee transportation, office pickup & drop, worker cabs, industrial area transport, corporate shuttles, monthly cab hire, and executive business travel solutions. Professional staff transport for Andheri East companies."
  />

  <meta
    name="keywords"
    content="Marol MIDC Employee Cab, Corporate Shuttle Andheri, Office Pickup Drop Marol, Worker Cab Marol Andheri, Industrial Transport Marol MIDC, Monthly Cab Hire Marol, Business Travel Cab Andheri, Affordable Staff Cab Marol MIDC, Outstation Cab Marol, Sedan Cab Marol Andheri, SUV Cab Andheri MIDC, Best Corporate Cab Marol, Employee Commute Andheri East, Corporate Fleet Marol MIDC, Staff Shuttle Andheri East"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/46.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinmarolmidc;